<script>
import TurnoverDesktopView from "./TurnoverDesktopView.vue";

/**
 * Desktop list layout bridge.
 * Renders TurnoverDesktopView using the parent list instance as
 * context so template bindings and $refs stay on list.vue (provide/inject).
 */
export default {
  name: "TurnoverDesktopBridge",
  inject: ["turnoverList"],
  render() {
    const list = this.turnoverList;
    const viewOptions =
      TurnoverDesktopView.options || TurnoverDesktopView;
    const render = viewOptions.render;

    if (!list || typeof render !== "function") {
      return null;
    }

    const options = list.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    // Keep shell `_scopeId` so scoped CSS on list.vue applies to the
    // bridged desktop template (same pattern as entrepot list).
    options.staticRenderFns = viewOptions.staticRenderFns;

    try {
      return render.call(list, list.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
